import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { range } from "lodash";
export const StarRating = ({ name, value, count, onChange }) => (_jsx("div", { "data-test-id": "star-rating", children: range(1, count + 1).map(option => (_jsx("label", { className: cx("star-rating__item", {
            "star-rating__item--active": option <= Number(value),
        }), children: _jsx("input", { type: "radio", name: name, value: option, onChange: () => onChange(option) }) }, option))) }));
StarRating.defaultProps = {
    value: 0,
    count: 5,
    onChange: () => { },
};
